<template>
	<div>
		<div class="goods-box">
			<div class="goods-content">
				<div class="content-item goods-text" @click="toGoodsDetail">
					<span class="presale-style" v-if="goodsInfo.presaleId">{{ $t('home.home.336045-2') }}</span><span class="presale-style activity-labele" v-if="goodsInfo.activityType == '抢购'">{{ $t('home.home.336045-3') }}</span> <span class="text-name" v-addGoodsTxtStyle v-popover="goodsInfo.goodsId">{{goodsInfo.goodsName}}</span>
				</div>
				<div class="content-item goods-price" v-show="isShowPrice">
					{{$currency.symbol}}{{goodsInfo.goodsPrice}}
					<div v-show="goodsInfo.score > 0">+{{goodsInfo.score}}{{ $t('home.home.336045-4') }}</div>
					<!-- <span v-if="!isAllInfoAlreadyLoaded">{{$currency.symbol}}{{goodsInfo.goodsPrice}}<span v-show="goodsInfo.score > 0">+{{goodsInfo.score}}积分</span></span>
					<span v-else-if>{{$currency.symbol}}{{isSingleSpecUnit? goodsSpecUnitList[0].executionPrice : goodsInfo.goodsPrice}}<span v-show="goodsSpecUnitList[0].score > 0 && !goodsSpecUnitList[0].isHaveActMaketingInfo">+{{goodsSpecUnitList[0].score}}积分</span></span> -->
				</div>
				<div class="content-item goods-count">
					<el-input v-if="isSingleSpecUnit" class="count-input" maxlength="10" :placeholder="placeholder" @blur="inputBlur" @focus="inputFocus" v-model="singleSpecUnitGoodsCount" @input="(newVal) => {changeGoodsCount(newVal,0)}"></el-input>
					<el-input v-else class="count-input" maxlength="10" :placeholder="placeholder" @focus="inputFocus" @blur="inputBlur"></el-input>
				</div>
				<div class="content-item goods-addcart">
					<img class="cart-img" @click="singleSpecUnitAddShopCart" src="../../assets/images/icon-goods-cart.svg" />
					<div class='cart-bubble' v-if="goodsInfo.shoppingCartCount>0">{{goodsInfo.shoppingCartCount>99?"99+":goodsInfo.shoppingCartCount}}</div>
				</div>
			</div>
			<div class="goods-label" v-if="(goodsInfo.labelNameList || []).length > 0">
				<span class="button-border" v-for="item in goodsInfo.labelNameList">
					{{item}}
				</span>
			</div>
		</div>


		<el-popover placement="bottom" :close-delay="0" width="200" :ref="goodsInfo.goodsId" trigger="hover">
			<div v-addPopMouseEnter class="popover-content">
				<div class="popover-text">{{goodsInfo.goodsName}}</div>
				<div style="text-align: center;">
					<img class="popover-img" :src="$utils.set400Img(goodsInfo.goodsImg)" />
				</div>
			</div>
		</el-popover>

		<el-dialog :title="$t('goods.WholeSaleGoodsItem.833487-7')" :visible.sync="specDialogVisible" width="950px" center>
			<div class="dialog-content" v-if="specDialogVisible">
				<el-table :header-row-style='{backgroundColor:"#F8F8F8 !important"}' max-height="500px" :data="goodsSpecUnitList" style="width: 100%">
					<el-table-column align='center' prop="date" :label="$t('goods.WholeSaleGoodsItem.833487-8')" width="100px">
						<template slot-scope="scope">
							<el-image class="popover-img" style="width: 50px;height: 50px;" :src="$utils.set400Img(scope.row.picUrl)" :preview-src-list="[$utils.set400Img(scope.row.picUrl)]">
								<div slot="error" class="image-slot">
									<el-image class="popover-img" :src="$utils.getDefaultImg()" :preview-src-list="[$utils.getDefaultImg()]"></el-image>
								</div>
							</el-image>
						</template>
					</el-table-column>
					<el-table-column align='center' header-align='center' prop="specName" :label="$t('goods.WholeSaleGoodsItem.833487-9')" width="300px">
						<template slot-scope="scope">
							<div class="text-2line">{{scope.row.specName}}</div>
						</template>

					</el-table-column>
					<el-table-column align='center' prop="address" :label="$t('goods.goodsdetail.362050-9')" width="200px">
						<template slot-scope="scope">
							<div class="goods-price" v-show="isShowPrice" style="text-align: center;width: 100%;">
								{{$currency.symbol}}{{scope.row.executionPrice}}<span v-show="scope.row.score > 0 && !scope.row.isHaveActMaketingInfo">{{ $t('goods.WholeSaleGoodsItem.833487-10',[scope.row.score]) }}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column align='center' prop="address" :label="$t('goods.goodsdetail.362050-15')" width="150px">
						<template slot-scope="scope">
							<span>{{scope.row.unitName+scope.row.countRateText}}</span>
						</template>
					</el-table-column>
					<el-table-column align='center' prop="address" :label="$t('goods.goodsdetail.362050-16')" width="150px">
						<template slot-scope="scope">
							<el-input class="count-input" style="width: 80%;" maxlength="10" v-model="scope.row.goodsCount" @input="(newVal) => {changeGoodsCount(newVal,scope.row.specIndex)}" :max="Math.floor(scope.row.canBuyCount)"></el-input>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div v-if="goodsInfo.isOpenGoodsBuyRestriction && goodsInfo.customerLimitCount > 0" style="margin-top: 5px;">{{ $t('goods.WholeSaleGoodsItem.833487-11',[goodsInfo.goodsBuyRestrictionTypeText,goodsInfo.customerLimitCount,goodsInfo.baseUnitName]) }}</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="_addShopCart">{{ $t('goods.WholeSaleGoodsItem.833487-12') }}</el-button>
			</span>
		</el-dialog>

		<!-- 货品检测弹窗 -->
		<check-goods-dialog :isShowDialog.sync="isShowCheckGoodsDialog" :hasValidGoodsTip="$t('goods.WholeSaleGoodsItem.833487-13')" :goodsList="cannotOrderGoodsList" :isNoValidGoods="isNoStockAll" :isCancelOfGoHome='false' @cancel="cancelCheckModal" :isFromWholeSale='true'>
		</check-goods-dialog>
	</div>
</template>

<script>
	import checkGoodsDialog from '../../components/trade/CheckGoodsDialog.vue';
	import goodsUtils from '../../utils/api-utils/api-goods.js';
	import {
		getMarketingInfoListBySpec,
		getSpecTimedSaleInfoList
	} from '../../utils/api-utils/api-activity.js';
	import commonUtlis from '../../utils/common-utlis.js';
	export default {
		name: 'WholeSaleGoodsItem',
		directives: {
			// 在模板中启用 v-focus
			addPopMouseEnter: {
				bind(el) {
					el.addEventListener("mouseenter", (e) => {
						el.parentElement.style.display = "none"
					});
				}
			},
			addGoodsTxtStyle: {
				bind(el) {
					el.addEventListener("mouseenter", (e) => {
						el.style.color = '#ff2b2a'
					});

					el.addEventListener("mouseleave", (e) => {
						el.style.color = '#000'
					});
				}
			},
		},
		props: {
			goodsInfo: {
				type: Object
			},
			isShowPrice: {
				type: Boolean
			},
		},
		components: {
			"check-goods-dialog": checkGoodsDialog,
		},
		data() {
			return {
				isAllInfoAlreadyLoaded: false,
				specDialogVisible: false, // 规格单位弹窗是否展示
				isSingleSpecUnit: true, // 单规格单位商品
				goodsSpecUnitList: [], // 商品规格单位数据
				isShowCheckGoodsDialog: false, // 是否展示库存检测弹窗，存在库存不足的货品就展示
				isNoStockAll: false, // 库存检测弹窗
				cannotOrderGoodsList: [], // 库存检测弹窗
				singleSpecUnitGoodsCount: '', // 单规格单位商品数量modal
				placeholder: '',

			}
		},
		async created() {
			// 是否是单规格单位商品
			this.isSingleSpecUnit = !this.goodsInfo.isMulti && !this.goodsInfo.isMultiUnit;
		},
		methods: {
			async getGoodsSkuList() {
				let tempGoodsSpecList = await goodsUtils.getGoodsSkuList(this.goodsInfo.goodsId);

				if (!tempGoodsSpecList || tempGoodsSpecList.length == 0) {
					return
				}

				let goodsUnitInfoList = this.goodsInfo.unitInfoList || []
				// 基础单位
				let baseUnitName = goodsUnitInfoList.length > 0 && goodsUnitInfoList.find(item => item.isBaseUnit == "1").unitName;
				let goodsSpecUnitList = []
				let specIndex = 0
				let that = this;
				tempGoodsSpecList.forEach(specItem => {
					// 获取套餐商品 需要定义新变量
					let specUnitList = that.goodsInfo.goodsType == 1 ? JSON.parse(specItem.originalSpecInfo.unitSetting || '[]') : goodsUnitInfoList

					// 套餐商品 需要重新 获取基础单位
					if (that.goodsInfo.goodsType == 1) {
						baseUnitName = specUnitList.length > 0 && specUnitList.find(item => item.isBaseUnit == "1").unitName || "";
					}

					// 过滤未上架单位
					specUnitList = specUnitList.filter(item => item && item.isOn == 1);

					// 商品选购数量
					specItem.goodsCount = "";
					specItem.canBuyCount = 0;

					specUnitList.forEach(unitItem => {
						// 单位比例的展示文本
						let countRate = Number(unitItem.countRate);
						let countRateText = unitItem.isBaseUnit == "1" ? '' : '（' + countRate + baseUnitName + '）';

						goodsSpecUnitList.push({
							...specItem,
							unitName: unitItem.unitName,
							specIndex,
							countRateText,
							countRate
						})
						specIndex = specIndex + 1;
					})
				})

				this.goodsSpecUnitList = goodsSpecUnitList;
			},


			/**
			 * 补充所有扩展信息（营销活动、抢购活动、库存、价格）
			 * @param {*} goodsList 
			 */
			completeAllExtendedInfo() {
				// 请求集合
				return new Promise(async (resolve, reject) => {
					let promiseList = [
						this.__completeMarketingInfo(this.goodsSpecUnitList),
						this.__completeTimedActivityInfo(this.goodsSpecUnitList),
						this.__completeStockInfo(this.goodsSpecUnitList),
						this.__completePriceInfo(this.goodsSpecUnitList),
					];

					// 等待所有接口执行完成
					Promise.all(promiseList).then(() => {
						resolve();
					});
				});
			},

			/**
			 * 补充营销活动信息
			 */
			__completeMarketingInfo(specList) {
				return new Promise(async (resolve, reject) => {
					// 获取规格信息
					let specIdList = specList.filter(t => ![1, 2].includes(t.actType)).map(t => t.specId);

					// 没有规格信息则不需要获取
					if (!(specIdList && specIdList.length > 0)) {
						resolve();
						return;
					}

					// 获取规格的营销活动信息
					let allSpecMarketingInfoList = await getMarketingInfoListBySpec(specIdList);
					// 没有营销活动信息，则直接跳出
					if (!(allSpecMarketingInfoList && allSpecMarketingInfoList.length > 0)) {
						resolve();
						return;
					}

					// 补充活动信息
					specList.forEach(spec => {
						// 找到当前商品的活动信息
						let cartMarketingInfo = allSpecMarketingInfoList.filter(t => t.specId == spec.specId && t.unitName == spec.unitName);
						if (cartMarketingInfo && cartMarketingInfo.length > 0) {
							// 补充营销活动信息到购物车
							spec.marketingInfoList = cartMarketingInfo;
							return;
						}

						// 当前单位没有直接设置促销活动，则找到基础单位的策略，进行换算获取
						let baseUnitMarketingInfoList = allSpecMarketingInfoList.filter(t => t.specId == spec.specId && t.unitName == spec.baseUnit);
						if (baseUnitMarketingInfoList.length <= 0) {
							return;
						}
						// 基础单位转换率
						let countRate = parseFloat(spec.countRate);
						// 新的营销活动策略
						let convertMarketingInfoList = [];
						baseUnitMarketingInfoList.forEach(item => {
							let marketingItem = JSON.parse(JSON.stringify(item));
							// 执行价格向上保留两位小数
							marketingItem.favorablePrice = Math.ceil(item.favorablePrice * countRate * 100) / 100;
							// 向上取整
							marketingItem.limitCount = Math.ceil(item.limitCount / countRate);
							marketingItem.upperLimitCount = Math.ceil(item.upperLimitCount / countRate);
							marketingItem.unitName = spec.unitName;
							convertMarketingInfoList.push(marketingItem);
						});
						// 根据辅助单位生产的促销价格
						spec.marketingInfoList = convertMarketingInfoList;
					});
					resolve();
				});
			},

			/**
			 * 补充限时抢购活动信息
			 */
			__completeTimedActivityInfo(specList) {
				return new Promise(async (resolve, reject) => {
					if (!this.goodsInfo.activityId || this.goodsInfo.activityId == 0) {
						return resolve();
					}

					// 获取活动商品的规格信息
					let specInfoList = specList.map(t => {
						return {
							saleId: this.goodsInfo.activityId,
							specId: t.specId
						};
					});

					// 没有活动信息则不需要获取
					if (!(specInfoList && specInfoList.length > 0)) {
						resolve();
						return;
					}

					// 获取规格的活动信息
					let timedActivityInfoList = await getSpecTimedSaleInfoList(specInfoList);
					// 没有活动信息，则直接跳出
					if (!(timedActivityInfoList && timedActivityInfoList.length > 0)) {
						resolve();
						return;
					}

					// 补充活动信息
					specList.forEach(spec => {
						// 找到当前商品的活动信息
						let actInfo = timedActivityInfoList.find(t => t.specId == spec.specId && t.saleId == this.goodsInfo.activityId && t.unit == spec.unitName);
						if (actInfo && actInfo.saleId) {
							// 将限时抢购活动价格填充到执行价格
							spec.executionPrice = actInfo.price;
							spec.timeSalePrice = actInfo.price;
							// 补充活动信息到购物车
							spec.timedActivityInfo = actInfo;
							spec.actId = actInfo.saleId;
							spec.actType = "1";
							// 抢购活动的最小购买量和单次购买量忽略
							spec.minCount = actInfo.minCount || 1;
							spec.stepCount = 1;
							// 补充积分
							spec.timeSaleScore = actInfo.score || 0;
							spec.score = actInfo.score || 0;
						}
					});
					resolve();
				});
			},


			/**
			 * 补充库存信息
			 */
			__completeStockInfo(specList) {
				return new Promise(async (resolve, reject) => {
					// 无数据不做处理
					if (!(specList && specList.length > 0)) {
						resolve();
						return;
					}

					// 获取sku库存列表
					let specIdList = [...new Set(specList.map(t => t.specId))];
					let skuStockList = await commonUtlis.getAllNeedInfoByConfigList(specIdList, goodsUtils.getSkuStockList);

					// 遍历需要补充的sku列表，进行价格补充
					specList.forEach(spec => {
						// 获取当前规格的库存信息
						let stockInfo = skuStockList.find(t => t.skuId == spec.specId && t.unitName == spec.unitName) || {};
						// 补充库存
						spec.stock = stockInfo.stock || 0;

					});
					resolve();
				});
			},

			/**
			 * 补充价格信息
			 */
			__completePriceInfo(specList) {
				return new Promise(async (resolve, reject) => {
					// 无数据不做处理
					if (!(specList && specList.length > 0)) {
						resolve();
						return;
					}

					// 获取sku价格列表
					let specIdList = [...new Set(specList.map(t => t.originalSpecId || t.specId))];
					let skuPriceList = await commonUtlis.getAllNeedInfoByConfigList(specIdList, goodsUtils.getSkuPriceList);
					// 遍历需要补充的sku列表，进行价格补充
					specList.forEach(spec => {
						// 获取当前规格的价格信息
						let priceInfo = skuPriceList.find(t => t.skuId == (spec.originalSpecId || spec.specId) && t.unitName == spec.unitName) || {};
						// 基础价格补充
						spec.memberPrice = priceInfo.memberPrice || 0; // 会员价
						spec.referencePrice = priceInfo.referencePrice || 0; // 参考价（综合零售价和付费会员执行价）
						spec.executionPrice = spec.timeSalePrice || priceInfo.executionPrice || 0; // 最终执行价（营销活动会根据数量等调整）
						spec.score = spec.timeSaleScore || priceInfo.score || 0; // 积分
						spec.isBargainGoods = priceInfo.isBargainGoods; // 是否为特价商品
					});
					resolve();
				});
			},

			/**
			 * 处理最小购买量和单次购买量
			 */
			checkGoodsCount(specList) {
				let isAllowOutOfStock = localStorage.getItem("isOpenZeroStockBuy") == "1";
				// 补充数据
				specList.forEach(spec => {
					// 普通商品补充可购数量 
					spec.canBuyCount = spec.stock || 0;

					// 是否为抢购商品，是则需要根据活动剩余商品重新计算
					if (spec.timedActivityInfo && spec.timedActivityInfo.saleId) {
						spec.isTimeSaleGoods = true;
						spec.timedActivityInfo.goodsCount = spec.timedActivityInfo.goodsCount || 9999 // 为空则不限
						spec.timedActivityInfo.limitCount = spec.timedActivityInfo.limitCount || 9999 // 为空则不限

						// 计算剩余数量
						let leftGoodsCount = spec.timedActivityInfo.goodsCount - spec.timedActivityInfo.boughtCount;
						// 比较库存和抢购商品数量，较小者作为库存
						spec.stock = isAllowOutOfStock ? leftGoodsCount : Math.min(spec.stock, leftGoodsCount);
						// 处理每人限购情况
						spec.canBuyCount = spec.stock;
					} else {
						// 处理每人限购情况
						spec.canBuyCount = isAllowOutOfStock ? 99999999 : spec.stock;
					}

					if (spec.timedActivityInfo && spec.timedActivityInfo.limitCount > 0) {
						// 计算当前用户还可以购买的数量
						let canBuyCount = spec.timedActivityInfo.limitCount - (spec.timedActivityInfo.selfBoughtCount || 0);
						// 和库存取小处理
						spec.canBuyCount = Math.min(spec.canBuyCount, canBuyCount);
					}


				});
			},

			/**
			 * 修改订购量
			 */
			changeGoodsCount(value, index) {
				let newVal = value;
				let selectSpecUnitInfo = this.goodsSpecUnitList[index] || {};

				// 等待规格数据补充
				if (!this.isAllInfoAlreadyLoaded) {
					this.singleSpecUnitGoodsCount = '';
					selectSpecUnitInfo.goodsCount = '';
					return
				}

				if (!value) {
					this.singleSpecUnitGoodsCount = '';
					selectSpecUnitInfo.goodsCount = '';
					return
				}

				// 规格单位数据缺失
				if (!selectSpecUnitInfo) {
					this.singleSpecUnitGoodsCount = '';
					selectSpecUnitInfo.goodsCount = '';
					return
				}

				// 数量处理
				selectSpecUnitInfo.goodsCount = this.isSingleSpecUnit ? this.singleSpecUnitGoodsCount : selectSpecUnitInfo.goodsCount

				// 最大值小于等于0直接返回
				let max = selectSpecUnitInfo.canBuyCount;
				if (max <= 0) {
					selectSpecUnitInfo.goodsCount = '';
					this.singleSpecUnitGoodsCount = '';
					this.$message.error(this.$t('goods.WholeSaleGoodsItem.833487-14',[max]));
					return
				}

				let minCount = parseInt(selectSpecUnitInfo.minCount);
				let stepCount = parseInt(selectSpecUnitInfo.stepCount);
				newVal = value < 0 ? '0' : value;
				newVal = Number(newVal.replace(/[^\d]/g, ""));

				// 可购量 不满足 最小起购量
				if (max <= minCount) {
					selectSpecUnitInfo.goodsCount = '';
					this.singleSpecUnitGoodsCount = '';
					this.$message.error(this.$t('goods.WholeSaleGoodsItem.833487-15',[max,minCount]));
					return
				}

				let errorMsg = ''

				// 可购量 
				if (newVal > max) {
					newVal = max;
					errorMsg = this.$t('goods.WholeSaleGoodsItem.833487-14',[max]);
				}

				//  最小起购量
				if (newVal < minCount) {
					newVal = minCount;
					errorMsg = this.$t('goods.WholeSaleGoodsItem.833487-16',[minCount]);
				}

				// 按 最小起购量 和 购买倍数 计算数量
				if ((newVal - minCount) % stepCount > 0) {
					newVal = minCount + Math.ceil((newVal - minCount) / stepCount) * stepCount;
					// 计算后如果大于可购数量
					errorMsg = newVal > max ? this.$t('goods.WholeSaleGoodsItem.833487-17',[max,stepCount,minCount]) : this.$t('goods.WholeSaleGoodsItem.833487-18',[stepCount,minCount]);
					newVal = newVal > max ? (newVal - stepCount) : newVal
				}

				// 错误提示
				errorMsg && this.$message.error(errorMsg);

				// 不参与限时抢购活动时获取命中的阶梯价价格
				if (selectSpecUnitInfo.marketingInfoList && !selectSpecUnitInfo.timedActivityInfo) {
					let marketingInfo = selectSpecUnitInfo.marketingInfoList.find(t => newVal >= t.limitCount && newVal <= t.upperLimitCount);
					if (marketingInfo) {
						// 金额等信息赋值的返回结果
						selectSpecUnitInfo.executionPrice = marketingInfo.favorablePrice;
						selectSpecUnitInfo.marketingInfo = marketingInfo;
						selectSpecUnitInfo.isHaveActMaketingInfo = true;
					} else {
						selectSpecUnitInfo.executionPrice = selectSpecUnitInfo.memberPrice;
						selectSpecUnitInfo.marketingInfo = {};
						selectSpecUnitInfo.isHaveActMaketingInfo = false;
					}
				}


				// 更新goodsSpecUnitList 并渲染
				this.singleSpecUnitGoodsCount = this.isSingleSpecUnit ? newVal : this.singleSpecUnitGoodsCount;
				this.goodsSpecUnitList[index].goodsCount = newVal;
				let tempGoodsSpecUnitList = JSON.parse(JSON.stringify(this.goodsSpecUnitList))
				this.goodsSpecUnitList = tempGoodsSpecUnitList;
			},

			/**
			 * 选择框点击
			 */
			async inputFocus() {
				this.placeholder = this.$t('goods.WholeSaleGoodsItem.833487-4')

				// 正在加载规格信息
				if (this.isLoadingExtraInfo) {
					return
				}

				// 第一次点击需要补充规格活动、库存、价格信息
				await this._loadGoodsExtraInfo()

				// 判断是否存在规格单位数据
				if (this.goodsSpecUnitList.length === 0) {
					this.$message.error(this.$t('goods.WholeSaleGoodsItem.833487-5'));
					return;
				}

				// 多规格单位 数量框点击
				if (!this.isSingleSpecUnit) {
					// 需要重置弹窗 选购数据
					this.goodsSpecUnitList.forEach(item => {
						item.goodsCount = "";
						item.executionPrice = item.marketingInfoList && !item.timedActivityInfo ? item.memberPrice : item.executionPrice;
					})

					// 打开弹窗
					this.specDialogVisible = true;
				}
			},

			/**
			 * 输入框失焦
			 */
			inputBlur() {
				this.placeholder = ''
			},

			/**
			 * 单规格单位商品点击加购
			 */
			async singleSpecUnitAddShopCart() {
				// 正在加载规格信息
				if (this.isLoadingExtraInfo) {
					return
				}

				// 第一次点击需要补充规格活动、库存、价格信息
				await this._loadGoodsExtraInfo()

				// 多规格单位商品 且 未打开弹窗
				if (!this.isSingleSpecUnit && !this.specDialogVisible) {
					// 需要重置弹窗 选购数据
					this.goodsSpecUnitList.forEach(item => {
						item.goodsCount = "";
						item.executionPrice = item.marketingInfoList && !item.timedActivityInfo ? item.memberPrice : item.executionPrice;
					})
					this.specDialogVisible = true;
					return;
				}

				// 单规格单位商品 且 没填加购数量
				if (this.isSingleSpecUnit && !this.goodsSpecUnitList[0].goodsCount) {
					this.goodsSpecUnitList[0].goodsCount = this.goodsSpecUnitList[0].minCount
				}

				this._addShopCart();
			},

			/**
			 * 加载商品 规格活动等信息
			 */
			async _loadGoodsExtraInfo() {
				if (!this.isAllInfoAlreadyLoaded) {
					this.isLoadingInfo = true
					await this.getGoodsSkuList();

					await this.completeAllExtendedInfo();

					this.checkGoodsCount(this.goodsSpecUnitList);

					this.isSingleSpecUnit = this.goodsSpecUnitList.length == 1;

					this.isAllInfoAlreadyLoaded = true;
					this.isLoadingExtraInfo = false
				}
			},

			/**
			 * 加购
			 */
			_addShopCart() {
				let addShopCartSpecList = this.goodsSpecUnitList.filter(item => item.goodsCount > 0);

				if (addShopCartSpecList.length == 0) {
					return this.$message.error(this.$t('goods.WholeSaleGoodsItem.833487-6'));
				}

				// 校验库存
				if (!this.checkOrderGoodsStock(addShopCartSpecList)) {
					return;
				}

				// 关闭规格弹窗
				this.specDialogVisible = false;

				// 返回选择数据
				this.$emit('addShopCart',
					addShopCartSpecList.map(item => {
						let tmpcart = {
							goodsId: item.goodsId,
							specId: item.specId,
							goodsCount: item.goodsCount,
							unitName: item.unitName,
							countRate: item.countRate,
							actId: item.actId,
							actType: item.actType
						};

						// 套餐商品处理
						if (item.originalSpecInfo) {
							tmpcart.goodsId = item.originalSpecInfo.goodsId;
							tmpcart.specId = item.originalSpecInfo.specId;
							tmpcart.packageGoodsId = item.goodsId;
							tmpcart.packageSpecId = item.specId;
						}

						return tmpcart;
					})
				)
			},

			/**
			 * 检测下单货品库存
			 */
			async checkOrderGoodsStock(addShopCartSpecList) {
				try {
					// 生成检测数据
					let preCheckGoodsList = addShopCartSpecList.map(t => {
						return {
							goodsId: t.goodsId,
							specId: t.specId,
							unitName: t.unitName || "",
							goodsCount: t.goodsCount,
							activityType: t.actType || '0',
							actId: t.actId
						}
					});

					// 检测货品库存，结果包含可购和不可购两个列表
					let res = await goodsUtils.checkGoodsErpStock(preCheckGoodsList);

					if (res.baseUnitOverOrderGoodsList.length == 0) {
						return true;
					}

					// 超卖情况下，下单商品包含多单位
					if (this._checkCartHasMultiUnitOverOrder(res, addShopCartSpecList)) {
						this.isShowMultiUnitStockCheckModal = true;
						this.baseUnitOverOrderGoodsList = res.baseUnitOverOrderGoodsList;
					} else {
						// 数据渲染
						this.canOrderGoodsList = res.canOrderGoodsList; // 限购商品列表
						this.cannotOrderGoodsList = res.baseUnitOverOrderGoodsList; // 剩余可购规格Id
						this.isNoStockAll = false; // 是否无可购商品
						this.isShowCheckGoodsDialog = true; // 是否展示库存检测弹窗，存在库存不足的货品就展示
					}
					return false;

				} catch (e) {
					return true;
				}
			},

			/**
			 * 检测超卖情况下下单货品是否包含多单位
			 */
			_checkCartHasMultiUnitOverOrder: function(checkStockResult, addShopCartSpecList) {
				// 超卖商品的SpecId数组
				let resultSpecIdList = checkStockResult.baseUnitOverOrderGoodsList.map((item) => item.specId);
				let cartUnitOverOrderListLength = addShopCartSpecList.filter(t => resultSpecIdList.includes(t.specId)).length;
				return cartUnitOverOrderListLength > resultSpecIdList.length
			},

			/**
			 * 关闭检测弹窗
			 */
			cancelCheckModal() {
				this.isShowMultiUnitStockCheckModal = false;
				this.isShowCheckGoodsDialog = false;
			},

			/**
			 * 跳转商品详情
			 */
			toGoodsDetail() {
				let encode = window.btoa(window.encodeURIComponent(this.goodsInfo.goodsId));

				// 如果存在活动信息前往限时抢购商品详情
				if (this.goodsInfo.activityType.includes('抢购')) {
					this.$router.push({
						name: 'timedsalegoodsdetail',
						query: {
							saleId: this.goodsInfo.activityId,
							goodsId: this.goodsInfo.goodsId
						}
					});
					return
				}

				this.$router.push({
					name: 'goodsdetail',
					query: {
						id: encode
					}
				});
			}
		}
	}
</script>

<style scoped>
	.goods-box {
		padding: 10px;
		padding-left: 25px;
	}

	.goods-content {
		display: flex;
		justify-content: space-between;
	}

	.content-item {
		height: 40px;
		text-align: left;
	}

	.count-input {
		margin: auto;
		width: 100%;
	}

	.goods-text {
		width: 50%;
		height: fit-content;
		/* padding-top: 6px; */
		overflow: hidden;
		text-overflow: ellipsis;
		color: #000;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		align-self: center;
		padding-right: 10px;
		box-sizing: border-box;
		font-size: 14px;
	}

	.text-2line {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		align-self: center;
	}

	.goods-price {
		width: 17%;
		color: #FF2B51;
		height: fit-content;
		align-self: center;
		font-size: 15px;
	}

	.goods-count {
		width: 23%;
	}

	.goods-addcart {
		width: 10%;
		min-width: 40px;
		text-align: center;
		position: relative;
	}

	.cart-img {
		height: 30px;
		cursor: pointer;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.cart-bubble {
		height: 15px;
		min-width: 7px;
		padding: 0px 4px;
		line-height: 15px;
		border-radius: 15px 15px 15px 0;
		font-size: 11px;
		text-align: center;
		position: absolute;
		left: 70%;
		top: -7px;
		z-index: 10;
		background: linear-gradient(to bottom left, #F37A45, #FEB27A) !important;
		/* background: linear-gradient(to top right, #FDB581, #F89765) !important; */
		color: #FFFFFF !important;
	}

	.popover-text {
		text-align: center;
		margin-bottom: 10px;
	}

	.popover-img {
		width: 90%;
		height: 90%;
	}

	/deep/.el-table--scrollable-x .el-table__body-wrapper {
		overflow-x: hidden;
	}

	.dialog-content {
		border: 1px solid #EBEEF5;
		border-bottom: unset;
	}

	.presale-style {
		color: #FFFFFF;
		padding: 2px 8px;
		border-radius: 4px;
		margin-right: 4px;
		font-size: 12px;
		vertical-align: text-top;
	}

	.activity-labele {
		background: linear-gradient(92deg, #ECD6AF 0%, #F6E5C6 100%);
	}

	.goods-label {
		display: flex;
		flex-wrap: wrap;
		max-width: 90%;
		margin-top: 2px;
	}

	.button-border {
		border-radius: 3px;
		color: #f63;
		font-size: 12px;
		border: 1px solid #f63;
		height: 18px !important;
		line-height: 18px;
		margin-right: 3px;
		word-break: break-all;
		overflow: hidden;
		text-align: center;
		margin-top: 3px;
		padding-left: 5px;
		padding-right: 5px;
	}

	/deep/.el-table th,
	.el-table tr {
		background-color: #F8F8F8
	}

	.el-popper {
		transition: unset !important;
	}

	.text-name {
		cursor: pointer;
	}

	/deep/.el-input__inner::placeholder {
		text-align: center;
		font-size: 12px
	}

	/deep/.el-input__inner {
		padding: 0 8px;
	}
</style>